import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DatasetRequestParams, RequestService } from '@shared/services';
import { RequestParams } from '@shared/models/request-params.model';
import { EntityHelpers } from '@main/helpers/entity.helpers';
import {
    CampaignIdsPayload,
    GetCampaignsByKeywordsResponse,
} from '@main/reports/keywords/services/keywords.service.types';
import { BUSINESS_ENTITY } from '@main/enums';

@Injectable()
export class KeywordsApiService {
    constructor(private requestService: RequestService) {}

    fetchCampaignsIds({ filters, entities, pageNumber, pageSize }: CampaignIdsPayload): Observable<number[]> {
        /* Groups are flattened into the keywords they hold: the query is built from the keyword strings, a group id
         * would resolve to a different scope. */
        const keywords = EntityHelpers.uniqIds(EntityHelpers.flattenItems(entities).map(({ id }) => id)).join(' ');

        const requestParams = new RequestParams();

        requestParams.setPage(pageNumber, pageSize);

        const datasetParams: DatasetRequestParams = {
            datasetName: 'campaigns-by-keywords',
            useViewToken: true,
            customParams: {
                ...EntityHelpers.serializeFiltersParams(filters),
                keyword: keywords,
            },
            requestParams,
            labelEntityType: BUSINESS_ENTITY.Keyword,
            labelArea: 'widget_keywords_service',
        };

        return this.requestService.dataset<GetCampaignsByKeywordsResponse>(datasetParams).pipe(
            map(({ elements: campaigns, count }) => {
                const result = campaigns.map(({ id }) => id);
                result[Symbol.for('total')] = count?.total || 0;
                return result;
            }),
        );
    }
}
